"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.WizardLoader = void 0;
var _components = require("@ori-ui/components");
var _mui = require("@ori-ui/mui");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _jsxRuntime = require("react/jsx-runtime");
const WizardLoader = () => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Dialog, {
    open: true,
    hideCloseButton: true,
    ...getTestIdProps('wizard-loader'),
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      style: {
        display: 'grid',
        alignItems: 'center',
        justifyItems: 'center',
        height: '100%'
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_mui.CircularProgress, {})
    })
  });
};
exports.WizardLoader = WizardLoader;
